(function(){
  const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const routes=window.theme&&window.theme.routes||{cart_add_url:'/cart/add',cart_change_url:'/cart/change',cart_url:'/cart'};
  const track=(event,data)=>{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event},data||{}));};
  window.ggTrack=track;

  // Reveal
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target);}}),{rootMargin:'0px 0px -10% 0px'});
    $$('.reveal').forEach(el=>io.observe(el));
  } else $$('.reveal').forEach(el=>el.classList.add('is-visible'));

  // Mobile nav + search
  const nav=$('#MobileNav');
  $$('[data-menu-toggle]').forEach(b=>b.addEventListener('click',()=>{const open=!nav.classList.contains('is-open');nav.classList.toggle('is-open',open);$$('[data-menu-toggle]').forEach(x=>x.setAttribute('aria-expanded',open));if(open){const f=$('a,button',nav);f&&f.focus();}}));
  const sb=$('#SearchBar');
  $$('[data-search-toggle]').forEach(b=>b.addEventListener('click',()=>{sb.classList.toggle('is-open');b.setAttribute('aria-expanded',sb.classList.contains('is-open'));if(sb.classList.contains('is-open'))$('input',sb).focus();}));

  // Cart drawer
  const drawer=$('#CartDrawer');
  const openDrawer=()=>{if(!drawer)return location.href=routes.cart_url;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';const c=$('[data-cart-close]',drawer);c&&c.focus();};
  const closeDrawer=()=>{if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';};
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{if(drawer){e.preventDefault();openDrawer();}}));
  document.addEventListener('click',e=>{if(e.target.closest('[data-cart-close]'))closeDrawer();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeDrawer();nav&&nav.classList.remove('is-open');}});

  const refresh=async()=>{
    const r=await fetch(`${location.pathname}?sections=cart-drawer,header`);const j=await r.json();
    if(j['cart-drawer']&&drawer){const d=new DOMParser().parseFromString(j['cart-drawer'],'text/html');const n=$('#CartDrawerInner',d);n&&($('#CartDrawerInner').replaceWith(n));}
    if(j.header){const d=new DOMParser().parseFromString(j.header,'text/html');$$('.cart-count',d).forEach((c,i)=>{const t=$$('.cart-count')[i];if(t){t.textContent=c.textContent;t.dataset.count=c.dataset.count;}});}
  };

  // Add to cart (progressive enhancement over native forms)
  document.addEventListener('submit',async e=>{
    const f=e.target.closest('form[data-product-form]');if(!f)return;
    const submitter=e.submitter;
    const buyNow=submitter&&submitter.name==='buy_now';
    e.preventDefault();const btn=$('[type=submit]',f);btn&&(btn.disabled=true);
    try{
      const res=await fetch(routes.cart_add_url+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});
      const data=await res.json();
      if(!res.ok){alert(data.description||data.message||'Could not add to bag');return;}
      track('add_to_cart',{id:data.variant_id,name:data.product_title,price:data.final_price/100,quantity:data.quantity});
      if(buyNow){track('begin_checkout',{source:'buy_now'});location.href='/checkout';return;}
      await refresh();openDrawer();
    }catch(err){f.submit();}finally{btn&&(btn.disabled=false);}
  });

  // Drawer quantity/remove
  document.addEventListener('click',async e=>{
    const b=e.target.closest('[data-line-change]');if(!b)return;e.preventDefault();
    const line=+b.dataset.line,q=+b.dataset.quantity;
    await fetch(routes.cart_change_url+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity:Math.max(0,q)})});
    if(b.closest('.cart-page'))location.reload();else refresh();
  });
  document.addEventListener('click',e=>{if(e.target.closest('[data-checkout]'))track('begin_checkout');});

  // Quantity steppers
  document.addEventListener('click',e=>{const b=e.target.closest('[data-qty]');if(!b)return;const i=$('input',b.parentElement);i.value=Math.max(1,(+i.value||1)+(+b.dataset.qty));});

  // Product gallery: responsive srcset must change with the selected photo.
  // Delegate clicks so galleries also work after Shopify section reloads.
  document.addEventListener('click',e=>{
    const t=e.target.closest('[data-thumb]');if(!t)return;
    const root=t.closest('[data-product]');if(!root)return;
    const m=$('[data-main-image]',root);if(!m||!t.dataset.src)return;
    m.removeAttribute('srcset');
    m.removeAttribute('sizes');
    m.src=t.dataset.src;
    m.alt=t.dataset.alt||'';
    $$('[data-thumb]',root).forEach(x=>x.setAttribute('aria-current',x===t?'true':'false'));
  });

  // Product variants
  $$('[data-product]').forEach(root=>{
    const json=$('script[data-variants]',root);if(!json)return;const variants=JSON.parse(json.textContent);
    const idInput=$('input[name=id]',root),priceEl=$('[data-price]',root),btns=$$('[data-add]',root);
    const money=c=>(window.theme.moneyFormat||'R {{amount}}').replace(/\{\{\s*\w+\s*\}\}/,(c/100).toLocaleString('en-ZA',{minimumFractionDigits:2}).replace(/\u00a0/g,' '));
    const update=()=>{
      const sel=$$('fieldset[data-option]',root).map(fs=>{const c=$('input:checked',fs);return c&&c.value;});
      const v=variants.find(v=>v.options.every((o,i)=>o===sel[i]));
      if(!v){btns.forEach(b=>{b.disabled=true;});return;}
      idInput.value=v.id;
      if(priceEl)priceEl.innerHTML=money(v.price)+(v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s>`:'');
      btns.forEach(b=>{b.disabled=!v.available;if(b.dataset.add==='cart')b.textContent=v.available?b.dataset.label:b.dataset.soldout;});
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
      if(v.featured_media){const mediaId=typeof v.featured_media==='object'?v.featured_media.id:v.featured_media;const t=$(`[data-media-id="${mediaId}"]`,root);t&&t.click();}
    };
    $$('fieldset[data-option] input',root).forEach(i=>i.addEventListener('change',update));
    track('view_item',JSON.parse(root.dataset.productData||'{}'));
  });
  const col=$('[data-collection-view]');col&&track('view_item_list',{list:col.dataset.collectionView});
  const srch=$('[data-search-view]');srch&&track('search',{search_term:srch.dataset.searchView});
  $$('form[data-newsletter]').forEach(f=>f.addEventListener('submit',()=>track('sign_up',{method:'newsletter'})));
  if(document.querySelector('[data-order-complete]'))track('purchase');

  // Collection sort/filter auto-submit
  $$('[data-autosubmit]').forEach(el=>el.addEventListener('change',()=>el.form.submit()));
})();
